<template>
  <div class="problem" :style="styles">
    <div class="problem-title">
      <img src="@/assets/images/question.png" alt="" />
      <span>常见问题</span>
    </div>
    <div class="problem-content">
      <div v-for="(item,index) in content" :key="index" class="problem-list" @click="handleQuestion(item)">
        <p>* {{ item.question }}</p>
      </div>
    </div>
  </div>
</template>
<script>
/**
   * 常见问题
   */
import MyVue from '@/MyVue'
export default {
  name: 'Problem',
  props: {
    msg: {
      type: Object,
      required: true
    },
    styles: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      canClick: true
    }
  },
  computed: {
    content() {
      if (typeof this.msg.content === 'string') return JSON.parse(this.msg.content)
      return this.msg.content
    }
  },
  methods: {
    handleQuestion(item) {
      if (!this.canClick) return
      this.canClick = false
      MyVue.$emit('handleQuestion', item.question)
      // 避免快速重复点击
      setTimeout(() => {
        this.canClick = true
      }, 700)
    }
  }
}
</script>
<style lang="stylus" scoped>
  .problem {
    display: inline-block;
    position: relative;
    padding: 10px;
    box-sizing: border-box;
    font-size: 16px;
    text-align: left;
    word-break: break-all;
    border-radius: 6px;
    .problem-title {
      display flex
      align-items center
      border-bottom 1px solid #D8D8D8
      padding 0 0 4px
      line-height 26px
      > img {
        width: 26px;
        height: auto;
        margin-right 5px
      }
    }
    .problem-content {
      padding: 8px 8px 8px 25px;
      .problem-list {
        margin 8px 0
        p {
          color #5693FF
          font-size 14px
          cursor pointer
        }
      }
    }
  }
</style>
